import MarkdownPage from "@/lib/components/MarkdownPage";

const markdownData = `
# Slik bruker du Eventlista

Eventlista er en sosial eventplanlegger. Legg inn bilde, tittel, tidspunkt, sted og beskrivelse, velg farge, og publiser eventet.

Hvert event får sin egen unike link ( for eksempel https://eventlista.no/e/n2036evb ). Denne linken kan deles med de du vil invitere.

Andre som er innlogget og følger ditt event, kan få oppdateringer via push-varsel. Eventer har i tillegg en egen underside for diskusjon, oppdateringer, hyping, eller hva du enn har lyst til å skrive.

## Hvordan legger jeg ut eventer?
For å legge ut eventer må du [registrere brukerprofil](/u/account/create) og logge inn.

Eventer kan være offentlige, hemmelige eller private:
* Offentlige eventer er søkbare på Eventlista og Internett.
* Hemmelige eventer kan brukes av alle som har fått lenken til eventet.
* Private eventer krever innlogging og vises kun for de som er invitert direkte.

## Hvem kan bruke Eventlista?
Eventlista er gratis å bruke dersom du er en privatperson eller representerer en ideell organisasjon. Bedrifter må betale for å annonsere sine eventer hos oss.

## Hvordan kan jeg få varsel på mobil?
Last ned appen og lag deg en brukerkonto. Eventlista vil spørre deg om å aktivere varslinger. Du vil få varsel på alle oppdaterte eventer samt alle meldinger som blir besvart.

Eventlista-appen kan lastes ned på Play Store og App Store.

* [Last ned for Android](https://play.google.com/store/apps/details?id=no.sjosett.eventlista.twa)
* [Last ned for iPhone](https://apps.apple.com/app/eventlista/id6740991650)

*Sist oppdatert: 6. april 2026*
`

export default function Index() {
    return (
        <MarkdownPage markdown={markdownData}/>
    )
}